import React, { FC } from "react"
import classNames from "classnames"
import { Localstorage } from "@/lib/services"
import { LocalStorage } from "@/lib/types/LocalStorage"

import { UrlObject, parse } from "url"

type Tab = {
  identifier: string
  name: string
  role: string[]
}

type Props = {
  tabs: Tab[]
  selectedTab: string
  selectTab: (id: string) => void
}

export const AdminTabs: FC<Props> = (props) => {
  const user = Localstorage.get<LocalStorage>("next.user")

  const removeQueryParams = (url: string): string => {
    const parsedUrl: UrlObject = parse(url, true)

    delete parsedUrl.search
    delete parsedUrl.query

    return parsedUrl.pathname || ""
  }

  return (
    <div className="flex flex-col">
      {props.tabs.map(
        (tab, i) =>
          tab.role.includes(user?.role as string) && (
            <button
              key={tab.identifier}
              className={classNames({
                "md:text-sm text-xs p-2 -mb-0.5 truncate md:w-full w-62 text-left hover:bg-white/5 whitespace-nowrap border-b dark:border-zinc-800 border-zinc-200":
                  true,
                "dark:text-zinc-400 text-gray-500 border-transparent":
                  props.selectedTab !== removeQueryParams(tab.identifier),
                "bg-white/5 text-accent":
                  props.selectedTab === removeQueryParams(tab.identifier),
              })}
              onClick={() => props.selectTab(tab.identifier)}
            >
              {tab.name}
            </button>
          ),
      )}
    </div>
  )
}
